export default __webpack_public_path__ + "static/media/smarterChains-webcast.cc215d51.svg";